import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../shared/header/header.component';
import { AlfredClientComponent } from '@lyceo/alfred-client';
import { IonCard, IonCardContent, IonContent } from '@ionic/angular/standalone';
import { map, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-direct-link-session-page',
  templateUrl: './direct-link-session-page.component.html',
  styleUrls: ['./direct-link-session-page.component.scss'],
  imports: [
    HeaderComponent,
    AlfredClientComponent,
    IonContent,
    IonCard,
    IonCardContent,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectLinkSessionPageComponent {
  private readonly router: Router = inject(Router);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  protected directLinkSessionId$: Observable<string | undefined> =
    this.activatedRoute.params.pipe(map((p) => p['directLinkSessionId']));

  protected navigateToHome(): void {
    this.router.navigate(['/home']);
  }
}
